import { ContactOrganizerButton } from '@eventbrite/contact-organizer-button';
import { gettext } from '@eventbrite/i18n';
import { OrganizerPanel } from '@eventbrite/organizer-panel';
import { css } from 'emotion';
import React from 'react';
import {
    FollowOrganizerProps,
    GACodes,
    OrganizerPanelListingsProps,
} from '../../types';
import { FollowOrganizerWidget } from '../FollowOrganizer/FollowOrganizerRoot';
import { SocialLinks } from '../SocialLinks';

export const OrganizerPanelListings: React.FC<
    OrganizerPanelListingsProps & FollowOrganizerProps
> = (props) => {
    const {
        gaCategory,
        gaSettings,
        isAuthenticated,
        isGDPRCountry,
        organizerId,
        organizerData,
        organizers,
        userId,
        orgFacebook,
        orgTwitter,
        orgWebsite,
    } = props;

    return (
        <section className={css(styles.section)} aria-label="Organizer profile">
            <OrganizerPanel
                organizer={{
                    name: props.organizerName,
                    logoUrl: props.organizerProfilePicture,
                    url: props.organizerUrl,
                    description: props.organizerDescription || '',
                    of: props.organizerEventTitle || '',
                }}
                gaCategory={GACodes.GA_CATEGORY_LISTING}
            />
            <SocialLinks
                orgWebsite={orgWebsite}
                orgTwitter={orgTwitter}
                orgFacebook={orgFacebook}
            />
            <div className={css(styles.actions)}>
                <ul className="cc-list-actions">
                    {props.organizerName ? (
                        <li className="g-cell eds-l-mar-right-4">
                            <FollowOrganizerWidget
                                gaCategory={gaCategory}
                                gaSettings={gaSettings}
                                isAuthenticated={isAuthenticated}
                                isGDPRCountry={isGDPRCountry}
                                organizerId={organizerId}
                                organizerData={organizerData}
                                organizers={organizers}
                                userId={userId}
                            />
                        </li>
                    ) : null}
                    <li
                        className="g-cell"
                        aria-label={gettext('Contact').toString()}
                    >
                        <ContactOrganizerButton
                            {...{
                                organizerId: props.organizerId,
                                organizerName: props.organizerName,
                                captchaKey: props.captchaKey,
                                isVisible: false,
                                isAuthenticated: props.isAuthenticated,
                                eventName: props.eventName,
                                eventId: props.eventId,
                                gaCategory: props.gaCategory,
                                domNodeId: 'event-page',
                            }}
                        />
                    </li>
                </ul>
            </div>
        </section>
    );
};

export default OrganizerPanelListings;

const styles = {
    section: css`
        align-items: center;
        display: flex;
        flex-direction: column;
        margin: 40px auto 0 auto;
        max-width: 780px;
        text-align: center;
        overflow-wrap: break-word;
    `,
    actions: css`
        margin-bottom: 24px;

        .cc-list-actions {
            display: flex;
            align-items: center;
            list-style: none;
        }
    `,
};
